import { render, staticRenderFns } from "./WebpartTemplate.vue?vue&type=template&id=147f84c9"
import script from "./WebpartTemplate.vue?vue&type=script&lang=js"
export * from "./WebpartTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports